export default __webpack_public_path__ + "static/media/icon_edit.0f2469ed.svg";